// cliente/axiosClient.js
import axios from 'axios';

// Puedes configurar la URL base para todas las peticiones
const defaultOptions = ({
  baseURL: 'https://8f65-38-25-8-218.ngrok-free.app/api/',
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': '69420',
  },
});

export const axiosInstance = axios.create(defaultOptions);

/*
// Puedes configurar interceptores si necesitas agregar autenticación, etc.
axiosInstance.interceptors.request.use(
  (config) => {
    // Aquí puedes agregar un token de autenticación, por ejemplo
    const token = localStorage.getItem('token'); // O usar cookies, dependiendo de tu caso
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Aquí puedes manejar errores globalmente
    console.error('Error en la solicitud:', error);
    return Promise.reject(error);
  }
);
*/
